/**
 * OAuth 관련 플랫폼별 URI 처리
 */ function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { getPlatformInfo, getPlatformInfoSync } from './core';
/**
 * 앱별 커스텀 스킴 정의
 * Tauri 모바일 앱에서 사용할 커스텀 URI 스킴
 */ export var APP_CUSTOM_SCHEMES = {
    'edusense-frontend': 'com.ugot.edusense',
    'reward-app': 'com.ugot.reward',
    'meditation-app': 'com.ugot.meditation',
    'reward-business': 'com.ugot.business',
    'whisper-frontend': 'com.ugot.whisper'
};
/**
 * 앱별 웹 도메인 정의
 */ export var APP_WEB_DOMAINS = {
    'edusense-frontend': 'https://app.ugot.uk',
    'reward-app': 'https://reward.ugot.uk',
    'meditation-app': 'https://meditation.ugot.uk',
    'reward-business': 'https://reward-business.ugot.uk',
    'whisper-frontend': 'https://freestt.ugot.uk'
};
// 환경변수 접근 헬퍼
var getEnvVar = function(key) {
    var _this;
    // @ts-ignore - Vite 환경변수 접근
    if (typeof ((_this = import.meta) === null || _this === void 0 ? void 0 : _this.env) !== 'undefined') {
        // @ts-ignore - Vite 환경변수 접근
        return import.meta.env[key];
    }
    return undefined;
};
/**
 * OAuth2 Redirect URI를 플랫폼과 앱에 맞게 반환
 * 
 * @param appName - 앱 이름
 * @returns 플랫폼과 앱에 맞는 redirect URI
 */ export var getOAuth2RedirectUri = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function() {
        var appName, platformInfo, customScheme, envKey, redirectUri, webDomain, redirectUri1, webDomain1;
        var _arguments = arguments;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    appName = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : 'edusense-frontend';
                    return [
                        4,
                        getPlatformInfo()
                    ];
                case 1:
                    platformInfo = _state.sent();
                    switch(platformInfo.platform){
                        case 'tauri-mobile':
                            {
                                // Tauri 모바일: 앱별 커스텀 스킴 사용
                                customScheme = APP_CUSTOM_SCHEMES[appName];
                                if (!customScheme) {
                                    console.warn("[PlatformDetection] Unknown app for mobile: ".concat(appName, ", using default"));
                                    return [
                                        2,
                                        'com.ugot.edusense://oauth2/redirect'
                                    ];
                                }
                                // iOS vs Android 구분 (Tauri API 활용)
                                if (platformInfo.os === 'ios') {
                                    // iOS는 커스텀 스킴 사용
                                    return [
                                        2,
                                        "".concat(customScheme, "://oauth2/redirect")
                                    ];
                                } else if (platformInfo.os === 'android') {
                                    // Android는 앱 링크 사용 가능
                                    return [
                                        2,
                                        "".concat(customScheme, "://oauth2/redirect")
                                    ];
                                }
                                // 환경변수가 있으면 우선 사용
                                envKey = "VITE_OAUTH2_REDIRECT_URI_MOBILE_".concat(appName.toUpperCase().replace('-', '_'));
                                return [
                                    2,
                                    getEnvVar(envKey) || "".concat(customScheme, "://oauth2/redirect")
                                ];
                            }
                        case 'tauri-desktop':
                            {
                                // Tauri 데스크톱: localhost 또는 웹 도메인
                                redirectUri = getEnvVar('VITE_OAUTH2_REDIRECT_URI');
                                if (redirectUri) {
                                    return [
                                        2,
                                        redirectUri
                                    ];
                                }
                                // 데스크톱 앱은 웹 도메인으로 리다이렉트
                                webDomain = APP_WEB_DOMAINS[appName] || 'https://app.ugot.uk';
                                return [
                                    2,
                                    "".concat(webDomain, "/oauth2/redirect")
                                ];
                            }
                        case 'web':
                        default:
                            {
                                // 웹: 환경변수 또는 현재 도메인 사용
                                redirectUri1 = getEnvVar('VITE_OAUTH2_REDIRECT_URI');
                                if (redirectUri1) {
                                    return [
                                        2,
                                        redirectUri1
                                    ];
                                }
                                // 현재 도메인 기반으로 리다이렉트 URI 생성
                                if (typeof window !== 'undefined') {
                                    return [
                                        2,
                                        "".concat(window.location.origin, "/oauth2/redirect")
                                    ];
                                }
                                // 폴백: 앱별 기본 도메인 사용
                                webDomain1 = APP_WEB_DOMAINS[appName] || 'https://app.ugot.uk';
                                return [
                                    2,
                                    "".concat(webDomain1, "/oauth2/redirect")
                                ];
                            }
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return function getOAuth2RedirectUri() {
        return _ref.apply(this, arguments);
    };
}();
/**
 * 동기식 OAuth2 Redirect URI 반환 (캐시된 플랫폼 정보 사용)
 */ export var getOAuth2RedirectUriSync = function() {
    var appName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'edusense-frontend';
    var platformInfo = getPlatformInfoSync();
    switch(platformInfo.platform){
        case 'tauri-mobile':
            {
                var customScheme = APP_CUSTOM_SCHEMES[appName];
                if (!customScheme) {
                    console.warn("[PlatformDetection] Unknown app for mobile: ".concat(appName, ", using default"));
                    return 'com.ugot.edusense://oauth2/redirect';
                }
                var envKey = "VITE_OAUTH2_REDIRECT_URI_MOBILE_".concat(appName.toUpperCase().replace('-', '_'));
                return getEnvVar(envKey) || "".concat(customScheme, "://oauth2/redirect");
            }
        case 'tauri-desktop':
            {
                var redirectUri = getEnvVar('VITE_OAUTH2_REDIRECT_URI');
                if (redirectUri) {
                    return redirectUri;
                }
                var webDomain = APP_WEB_DOMAINS[appName] || 'https://app.ugot.uk';
                return "".concat(webDomain, "/oauth2/redirect");
            }
        case 'web':
        default:
            {
                var redirectUri1 = getEnvVar('VITE_OAUTH2_REDIRECT_URI');
                if (redirectUri1) {
                    return redirectUri1;
                }
                if (typeof window !== 'undefined') {
                    return "".concat(window.location.origin, "/oauth2/redirect");
                }
                var webDomain1 = APP_WEB_DOMAINS[appName] || 'https://app.ugot.uk';
                return "".concat(webDomain1, "/oauth2/redirect");
            }
    }
};
/**
 * 플랫폼별 취소 URI 반환
 * 
 * @param appName - 앱 이름
 * @returns 플랫폼과 앱에 맞는 취소 URI
 */ export var getCancelUri = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function() {
        var appName, platformInfo, customScheme, webDomain, webDomain1;
        var _arguments = arguments;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    appName = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : 'edusense-frontend';
                    return [
                        4,
                        getPlatformInfo()
                    ];
                case 1:
                    platformInfo = _state.sent();
                    switch(platformInfo.platform){
                        case 'tauri-mobile':
                            {
                                customScheme = APP_CUSTOM_SCHEMES[appName];
                                if (!customScheme) {
                                    console.warn("[PlatformDetection] Unknown app for mobile: ".concat(appName, ", using default"));
                                    return [
                                        2,
                                        'com.ugot.edusense://login'
                                    ];
                                }
                                return [
                                    2,
                                    "".concat(customScheme, "://login")
                                ];
                            }
                        case 'tauri-desktop':
                            {
                                webDomain = APP_WEB_DOMAINS[appName] || 'https://app.ugot.uk';
                                return [
                                    2,
                                    "".concat(webDomain, "/login")
                                ];
                            }
                        case 'web':
                        default:
                            {
                                if (typeof window !== 'undefined') {
                                    return [
                                        2,
                                        "".concat(window.location.origin, "/login")
                                    ];
                                }
                                webDomain1 = APP_WEB_DOMAINS[appName] || 'https://app.ugot.uk';
                                return [
                                    2,
                                    "".concat(webDomain1, "/login")
                                ];
                            }
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return function getCancelUri() {
        return _ref.apply(this, arguments);
    };
}();
/**
 * 동기식 취소 URI 반환
 */ export var getCancelUriSync = function() {
    var appName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'edusense-frontend';
    var platformInfo = getPlatformInfoSync();
    switch(platformInfo.platform){
        case 'tauri-mobile':
            {
                var customScheme = APP_CUSTOM_SCHEMES[appName];
                if (!customScheme) {
                    console.warn("[PlatformDetection] Unknown app for mobile: ".concat(appName, ", using default"));
                    return 'com.ugot.edusense://login';
                }
                return "".concat(customScheme, "://login");
            }
        case 'tauri-desktop':
            {
                var webDomain = APP_WEB_DOMAINS[appName] || 'https://app.ugot.uk';
                return "".concat(webDomain, "/login");
            }
        case 'web':
        default:
            {
                if (typeof window !== 'undefined') {
                    return "".concat(window.location.origin, "/login");
                }
                var webDomain1 = APP_WEB_DOMAINS[appName] || 'https://app.ugot.uk';
                return "".concat(webDomain1, "/login");
            }
    }
};
/**
 * 플랫폼별 로깅 헬퍼
 */ export var logPlatformInfo = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(appName) {
        var platformInfo, redirectUri, cancelUri;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getPlatformInfo()
                    ];
                case 1:
                    platformInfo = _state.sent();
                    return [
                        4,
                        getOAuth2RedirectUri(appName)
                    ];
                case 2:
                    redirectUri = _state.sent();
                    return [
                        4,
                        getCancelUri(appName)
                    ];
                case 3:
                    cancelUri = _state.sent();
                    console.log('[PlatformDetection] 현재 플랫폼 정보 (Tauri API):', _object_spread_props(_object_spread({}, platformInfo), {
                        appName: appName,
                        redirectUri: redirectUri,
                        cancelUri: cancelUri,
                        userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : 'N/A'
                    }));
                    return [
                        2
                    ];
            }
        });
    });
    return function logPlatformInfo(appName) {
        return _ref.apply(this, arguments);
    };
}();
